export default {
  go_today_matches: "浏览今日赛事",
  go_live_matches: "浏览滚球赛事",
  seven_days: "最近7天",
  fourteen_days: "最近14天",
  total_stake: "总投注额",
  hide: "隐藏",
  more_details: "更多细节",
  settled: "已结算",
  current_live: "当前滚球",
  prematch: "预赛",
  upcoming: "即将来临",
  loading: "正在加载...",
  open: "未结余额",
  close: "结余|关闭",
  // stake: "赌注",
  crdr: "输赢",
  item: "事项",
  valid: "有效投注",
  home_preferences: "主页首选项",
  quick_links: "快速连接",
  language: "语言",
  home_page: "主页",
  favorites: "我的最愛",
  note: "注意",
  running: "进行中",
  my_bets: "我的投注",
  my_account: "我的帐户",
  contact_us: "联系我们",
  report: "报告",
  help_support: "帮助支持",
  currency: "货币",
  others: "其他",
  welcome: "欢迎",
  password: "密码",
  sports: "体育博彩",
  my_sports: "体育",
  casino: "真人娱乐场",
  games: "游戏",
  e_sports: "电子竞技",
  esports2: "电子竞技",
  keno: "奇乐",
  lottery: "乐透",
  mobile: "智能手机",
  login: "登录",
  logout: "登出",
  bet_credit: "投注额度",
  given_credit: "信用额度",
  cash_balance: "现金余额",
  outstanding: "未结投注",
  nickname: "昵称",
  last_login: "最后登录",
  last_transaction: "最后交易",
  password_expiry: "密码过期",
  edit: "编辑",
  show_balance: "显示余额",
  bet_list: "投注历史",
  statement: "帐目",
  result: "赛果",
  message: "信息",
  settings: "设置",
  search_team: "搜索队名",
  hide_header: "隐藏标题",
  show_header: "显示标题",
  live_streaming: "直播",
  live_match: "实时比赛动态",
  live_chat: "Live Chat",
  account_id: "帐户ID",
  submit: "提交",
  change_account_password: "更改帐户密码",
  current_password: "当前密码",
  new_password: "新密码",
  confirm_new_password: "确认新密码",
  set_nickname: "设置昵称",
  account: "帐户",
  bet_slip: "投注单",
  my_bet: "我的投注",
  my_favorites: "我的最愛",
  live: "滚球",
  all_sports: "所有运动",
  early: "早盘",
  today: "今日赛事",
  parlay: "混合过关",
  parlay_early: "早盘混合过关",
  mix_parlay: "混合过关",
  mmo_parlay: "缅甸混合过关",
  mmo_odds: "缅甸赔率",
  new: "更新",
  single: "单笔投注",
  gmail: "信箱邮址",
  contact_number: "联络号码",
  desktop_view: "桌面版",
  back_to_lobby: "回到大厅",

  page_display: "页面显示",
  customize_sports_order: "自订体育赛事顺序",
  betting: "投注",
  action: "行动",
  save: "保存",
  display_language: "显示语言",
  odds_type: "赔率类型",
  page_type: "页面类型",
  page_size: "页面",
  show_score_map: "显示盈利预测图",
  default_event_sorting: "默认赛事排序",
  event_sorting: "赛事排序",
  market_type: "盘口类型",
  restore: "恢复",
  default_stake: "默认注金",
  accept_better_odds: "自动接收较佳赔率",
  accept_any_odds: "自动接收任何赔率",
  auto_refresh_odds: "自动刷新赔率",
  auto_refresh: "自动刷新",
  auto_refreshing: "自动刷新中。。。",
  date: "日期",
  choice: "选择",
  odds: "赔率",
  stake: "投注金额",
  stake_per_bet: "每注赌金",
  status: "状态",
  sort: "分类",
  remark: "备注",
  turnover: "交易额",
  credit: "支出",
  debit: "收入",
  commission: "佣金",
  balance: "余额",
  available_balance: "投注额度",
  betting_statement: "投注帐目",
  opening_balance: "前期余额",
  sportsbook: "体育博彩",
  livecasino: "真人娱乐场",
  bet_types: "投注类型",
  betting_rules: "投注规则",
  event: "赛事",
  // today: "今日",
  yesterday: "昨日赛事",
  outright: "优胜冠军",
  kickoff: "开赛",
  time: "时间",
  match: "赛事",
  first_half: "上半场比分",
  final: "最后赛果",
  team: "队名",
  bs: "大/小",
  oe: "单/双",
  sum: "总数",
  group: "组合",
  "no/": "编号",
  on: "开",
  off: "关",
  message_history: "最新讯息",
  normal_announcements: "一般公告",
  special_announcements: "特殊公告",
  personal_message: "个人讯息",
  from: "从",
  to: "到",
  id: "代码",
  outstanding_bet: "未完成交易",
  trans_time: "交易时间",
  win: "赢",
  loss: "输",
  draw: "和局",
  draw_cancel: "和局",
  bet_summary: "投注摘要",
  ref_no: "参考编号",
  lost: "输",
  lose: "输",
  lose_half: "输半",
  won: "赢",
  won_all: "全赢",
  won_half: "赢半",
  win_half: "赢半",
  subtotal: "小计",
  total: "总数",
  winlose: "输/赢",
  winner_rank: "获胜者排名",

  dec: "欧洲盘",
  hk: "香港盘",
  my: "马来盘",

  double_line: "双线双盘口",
  single_line: "单线单盘口",
  full_time: "全场",
  half_time: "半场",
  enable: "启用",
  disable: "不启用",
  normal_sorting: "普通排序",
  sort_by_time: "按时间排序",

  market: "盘口",
  all_markets: "全部盘口",
  main_markets: "主要盘口",
  other_markets: "其他盘口",

  main: "主要盘口",
  corners: "角球/罚牌",
  specials: "特别产品",

  dec_odds: "欧洲盘",
  hk_odds: "香港盘",
  my_odds: "马来盘",

  last_bet: "最后投注",
  customize: "自订",
  slots: "老虎机",

  quick_bet: "快速投注",
  select_leagues: "选择联赛",

  cancel: "取消",
  process_bet: "下注",
  remove_from_parlay: "從混合过关移除",

  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
  sunday: "星期日",

  min: "最低投注",
  max: "最高投注",
  payout: "贏取金額",
  max_payout: "最高贏取金額",

  accepted: "进行中",
  bets: "投注",
  waiting: "等待中",
  pending: "等待中",
  void: "已作废",
  void_list: "作废列表",

  yes: "是",
  no: "否",

  all_league: "所有联赛",
  match_completed: "已完场",
  match_pending: "赛事待定",
  match_cancelled: "退款",
  match_cancelled_1h: "上半场退款",
  match_cancelled_2h: "下半场退款",
  match_suspended: "赛事终止",
  match_suspended_1h: "上半场终止",
  match_suspended_2h: "下半场终止",
  mini_arcade: "迷你街机",

  over: "大",
  under: "小",
  home: "主",
  away: "客",
  odd: "单",
  even: "双",

  check_all: "全选",
  selected_only: "只显示已勾选",
  filtered: "筛选",
  turn_on: "开启功能",
  turn_off: "关闭功能",

  goal: "进球",
  id_odds: "印尼盘",

  general: "一般",
  special: "特殊",
  personal: "私讯",

  more_bet_types: "更多投注类型",
  scroll_bottom: "点击检查混合过关投注",

  continue_bet: "继续投注",
  customer_service: "Customer Service Hotline",
  reject: "取消",
  rejected: "已取消",
  swipe_to_search: "Swipe To Search",
  hotline: "Hotline",
  email: "Email",
  qq: "QQ",
  skype: "Skype",
  wechat: "Wechat",
  whatsapp: "Whatsapp",
  switch_to_desktop: "切换到桌面",

  events: "Events",
  brackets: "Brackets",
  standing: "Standing",
  telegram: "Telegram",

  big_small: "大/小",
  odd_even: "单/双",

  es_101: "地图 1",
  es_102: "地图 2",
  es_103: "地图 3",
  es_104: "地图 4",
  es_105: "地图 5",
  es_106: "地图 6",
  es_107: "地图 7",
  es_108: "地图 8",
  es_109: "地图 9",
  es_110: "地图 10",
  euro: "欧洲杯 2020",

  fd_101: "首奖",
  fd_102: "二奖",
  fd_103: "三奖",

  general_betting_rules: "一般投注规则",
  general_rules_market: "一般规则：市场（投注类型）",

  first_digit: "第一位数字",
  second_digit: "第二位数字",
  third_digit: "第三位数字",
  forth_digit: "第四位数字",
  total_4d: "4D 总数",
  total_3d: "3D 总数",
  total_1st2d: "第一2D总数",
  total_last2d: "最后2D总数",
  official_link: "官方链接",
  tnc: "一般条款和条件",

  sfv_101: "第一回合",
  sfv_102: "第二回合",
  sfv_103: "第三回合",
  sfv_104: "第四回合",
  sfv_105: "第五回合",

  roundof16: "16强",
  quater_finals: "8强",
  semi_finals: "半决赛",
  settlement: "结算",
  settled_amount: "结算金额",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "Macau Suite",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  suite_sexy: "Sexy Casino",
  score: "分数",
  winner: "优胜者",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pramagtic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  slot_epw: "Epicwin",

  soccer: "足球",
  basketball: "篮球",
  baseball: "棒球",
  tennis: "网球",
  esports: "电子竞技",
  american_football: "美式足球",
  athletics: "竞技",
  aussie_rules_football: "澳式足球",
  badminton: "羽毛球",
  bandy: "班迪球",
  beach_soccer: "沙滩足球",
  boxing: "拳击",
  cricket: "板球",
  cycling: "自行车",
  darts: "飞镖",
  field_hockey: "草地曲棍球",
  futsal: "室内足球（五人制足球）",
  gaelic_football: "盖尔式足球",
  golf: "高尔夫",
  handball: "手球",
  hurling: "板棍球",
  ice_hockey: "冰棍球",
  kabbadi: "卡巴迪",
  kof: "拳皇",
  mma: "综合格斗",
  motorsports: "赛车",
  muay_thai: "泰拳",
  netball: "篮网球",
  rugby: "橄榄球",
  sepak_takraw: "藤球",
  snooker: "撞球",
  squash: "壁球",
  table_tennis: "乒乓",
  volleyball: "排球",
  water_polo: "水球",
  winter_sports: "冬季运动",
  fd: "4D 特别彩",

  news: "最新消息",
  more: "更多",
  remember_stake: "记住赌注",
  confirm: "确认",
  parlay_slip: "混合过关投注单",
  parlay_slip_selection: "混合过关投注单选择",
  parlay_generator: "过关生成器",
  remove_all: "移除所有",
  add_more_selection: "添加更多选择",
  retain_selections: "保留选择",
  resolved_remark: "注意：顯示今天市場的投注。",
  hour: "小時",
  search: "搜索",
  w4d: "4D",
  fishing: "打鱼",
  deselect_all: "全部取消选择",
  select_all: "全选",
  done: "完成",
  tutorial_tooltips: "如何在主屏幕上安装此应用",
  tutorial: "教程",
  dismiss: "取消",
  video: "视频",
  settled_remark: "注意：显示当日盘口的投注，已结算的比赛门票将移至对帐单。",
  highlight: "体育视频",
  more_markets: "更多市场",
  all: "全部",
  sysparlay: "串关系统",
  fold: "串",
  combinations: "组合方式",
  matches: "比赛",
  play_now: "试玩",
  add: "添加",
  add_homescreen: "添加到主屏幕",
  total_winlose: "总数输/赢",
  folds_2: "2 串",
  folds_3: "3 串",
  folds_4: "4 串",
  folds_5: "5 串",
  folds_6: "6 串",
  folds_7: "7 串",
  folds_8: "8 串",
  folds_9: "9 串",
  folds_10: "10 串",
  folds_11: "11 串",
  folds_12: "12 串",
  newsinfo: "新闻与资讯",
  euroDate: "6月12日 - 7月12日",
  abandoned: "弃赛",
  transfer: "转帐",
  goto_statement: "前往帐目",
  no_record: "没有找到记录",
  no_bet: "没有赌注",

  random_pick: "生成",
  add_pick: "添加到投注单",

  worldcup: "世界杯 2022",
  time_remaining: "剩余时间",

  slot_championstar: "冠军之星",
  slot_fifafiesta: "足球派对",
  slot_penaltymania: "狂热罚球",
  minigame_dragon: "伏藏龙",
  minigame_illuvium: "怪兽大师",
  minigame_mobo: "奥林匹亚",
  egames: "V-Games",
  tournament: "锦标赛",
  joined: "仅限已加入",
  room_id: "房间编号",
  private: "私人",
  owner: "房主",
  entry_fee: "报名费",
  pool: "奖池 $",
  room: "房间",
  create_room: "创建房间",
  tomorrow: "明天",
  players: "玩家",
  selected: "已选择",
  select_matches: "选择场次",
  leave_room: "离开房间",
  join_now: "立即加入",
  last_betting_time: "最后下注时间",
  lose_all: "全输",
  feedback: "用户反馈",
  points: "积分",
  match_started: "-",
  details: "细节",
  total_points: "总积分",
  ranking: "排名",
  total_winning: "总奖金",
  first_prize: "一等奖",
  second_prize: "二等奖",
  third_prize: "三等奖",
  place: "排位",
  current_point: "当前分数",
  free_room: "免费房间",
  last_join_time: "最后加入时间",
  next: "下一步",
  prize: "奖金",
  jackpot: "中奖",
  tournament_refund: "锦标赛退款",
  refund: "退款",
  exclusive: "独家",
  play_to_earn: "玩游戏赚钱",
  archery: "射箭",
  olympic: "奥林匹克",
  ufc: "终极格斗冠军赛",
  sfv: "街头霸王V",
  winter_olympic: "冬季奥林匹克",
  ko: "击倒",
  no1: "第一名获胜者",
  adjustment: "调整",
  poker: "扑克",
  poker_db: "DB Poker",
  yellow: "黄色",
  blue: "蓝色",
  first_ball: "第一球",
  best_5_balls: "最佳五球",
  binary_allin: "Binary"
};
